import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { isNativeAndroid } from "../lib/billing";

// Finestra globale mostrata quando finiscono le consultazioni disponibili.
// Modal vero (non toast): sempre centrato, interamente visibile e scorribile su ogni dispositivo.
// Sul sito nessun acquisto: l'acquisto/abbonamento avviene solo nell'app Android.
export const QuotaGate = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onShow = () => setVisible(true);
    window.addEventListener("arcana-quota-exhausted", onShow);
    return () => window.removeEventListener("arcana-quota-exhausted", onShow);
  }, []);

  if (!visible) return null;

  const native = isNativeAndroid();

  const goPlans = () => {
    setVisible(false);
    window.location.href = "/piani";
  };

  return (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center bg-black/70 backdrop-blur-sm px-4 py-6"
      onClick={() => setVisible(false)}
      data-testid="quota-exhausted-overlay"
    >
      <div
        data-testid="quota-exhausted-toast"
        className="relative w-full max-w-md max-h-[85vh] overflow-y-auto rounded-2xl border border-amber-500/40 bg-[#1a0b2e] px-6 py-6 shadow-2xl shadow-black/60"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          data-testid="quota-exhausted-close"
          onClick={() => setVisible(false)}
          aria-label="Chiudi"
          className="absolute top-3 right-3 text-purple-300/60 hover:text-amber-200 transition-colors"
        >
          <X className="w-5 h-5" />
        </button>
        <p className="font-display text-amber-200 text-center text-lg tracking-wide pr-6" data-testid="quota-exhausted-title">
          Hai usato la tua consultazione gratuita di oggi.
        </p>
        {native ? (
          <>
            <p className="text-purple-200/80 text-sm text-center leading-relaxed mt-3" data-testid="quota-exhausted-text">
              Con l'abbonamento a 9,99 € al mese hai fino a 5 consultazioni al giorno e storico personale.
              E se prenoti un consulto privato con Virginia, da abbonata puoi chiederle uno sconto di 5 €:
              lo concordate direttamente insieme. Oppure puoi acquistare 3 consultazioni a 2,99 €, senza abbonamento.
              Scegli come continuare.
            </p>
            <div className="mt-6 flex flex-col items-stretch gap-3">
              <button
                data-testid="quota-subscribe-btn"
                onClick={goPlans}
                className="w-full rounded-full bg-[#d4a853] hover:bg-[#e0b964] transition-colors text-[#1a0b2e] font-bold py-3 text-sm tracking-wide"
              >
                Abbonati a 9,99 €
              </button>
              <button
                data-testid="quota-credits-btn"
                onClick={goPlans}
                className="w-full rounded-full border border-amber-500/50 hover:bg-amber-500/10 transition-colors text-amber-200 py-3 text-sm tracking-wide"
              >
                3 consultazioni a 2,99 €
              </button>
            </div>
          </>
        ) : (
          <>
            <p className="text-purple-200/80 text-sm text-center leading-relaxed mt-3" data-testid="quota-exhausted-text">
              Domani avrai una nuova consultazione gratuita. Per consultare più volte al giorno,
              l'abbonamento e i pacchetti di consultazioni si attivano dall'app Android di Arcana.
            </p>
            <div className="mt-6 flex flex-col items-stretch gap-3">
              <button
                data-testid="quota-plans-btn"
                onClick={goPlans}
                className="w-full rounded-full bg-[#d4a853] hover:bg-[#e0b964] transition-colors text-[#1a0b2e] font-bold py-3 text-sm tracking-wide"
              >
                Scopri come continuare
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
